export default "<p>\n  delete works!\n</p>\n"